export const DELETE_PRODUCT_FILE = 'DELETE_PRODUCT_FILE'
export const PRODUCT_ADD_FILE_MUT = 'PRODUCT_ADD_FILE_MUT'
export const EXTRACT_FROM_TERMSHEET = 'EXTRACT_FROM_TERMSHEET'
